import { queryOptions } from '@tanstack/react-query'
import { z } from 'zod'
import { apiRequest } from '@/shared/api'
import { type CommentEntityKind, CommentSchema } from '../model/types'

export const commentKeys = {
  byEntity: (kind: CommentEntityKind, id: string) => ['comment', kind, id] as const,
}

export function entityCommentsQueryOptions(kind: CommentEntityKind, id: string) {
  return queryOptions({
    queryKey: commentKeys.byEntity(kind, id),
    queryFn: async () => {
      const body = await apiRequest<{ items: unknown[] }>({
        method: 'GET',
        url: '/comments',
        query: { entity_kind: kind, entity_id: id },
      })
      return z.array(CommentSchema).parse(body.items)
    },
  })
}
